import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { connect, useDispatch } from 'react-redux';
import { getAlbums, getStash, setStash } from '../../../../redux/actions/stash';
import AlertConfirmModal from "../../AlertConfirmModal";

const CreateNewAlbumModal = ({
    activeAlbum,
    albumList,
    stash,
    showAlbumModal,
    stashSelected
}) => {
    const dispatch = useDispatch();

    const [albumName, setAlbumName] = useState('');
    const [error, setError] = useState('');
    const [busy, setBusy] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [modalBody, setModalBody] = useState('');

    const onChangeAlbumName = (e) => {
        setError('');
        setAlbumName(e.target.value);
    };

    const handleClose = () => {
        dispatch(setStash({
            ...stash,
            showAlbumModal: false
        }));
    };

    const handleCloseAlert = () => {
        const payload = {
            showAlbumModal: false,
            moveToAlbum: false,
            showMoveFolder: false,
        }
        dispatch(setStash({
            ...stash,
            ...payload,
        }));
        setShowAlert(false);
    }

    const handleSave = e => {
        e.preventDefault();

        if (albumName === '') {
            setError('Please input an album name');
        } else {
            setBusy(true);
            const formData = new FormData();
            formData.append('album_name', albumName);

            stashSelected.map((file, index) => {
                formData.append('media[]', file.media_id);
            });

            axios({
                method: 'post',
                url: '/api/albums',
                data: formData,
            })
                .then((response) => {
                    const createdAlbum = {
                        id: response.data,
                        album_name: formData.get('album_name'),
                        medias: [],
                        medias_img_count: 0,
                        medias_video_count: 0,
                    };

                    const payload = {
                        activeAlbum: createdAlbum,
                        albumAction: stashSelected.length === 0 ? '' : 'view_album',
                        moveToAlbum: stashSelected.length >= 1,
                        tabSelected: 'album',
                        busy: false,
                        stashSelected: [],
                        addMediaToAlbum: stashSelected.length === 0 ? false : true,
                    };

                    dispatch(setStash({
                        ...stash,
                        ...payload,
                    }));

                    dispatch(getAlbums());

                })
                .catch((error) => {
                    setBusy(false);
                    captureException(error);
                });

            setShowAlert(true);
            if (stashSelected.length === 0) {
                setModalBody('Successfully created new album');
            } else {
                setModalBody(`Media successfully added to ${albumName} album`);
            }
        }
    };

    useEffect(() => {
        let isMounted = true;

        return (() => {
            isMounted = false;
        });
        // do nothing
    }, []);

    return <>
        {
            !showAlert && <Modal
                show={showAlbumModal}
                onHide={handleClose}
                className="createAlbum-modal"
                centered
                size="sm"
            >
                <Modal.Header style={{ borderBottom: 0, paddingBottom: 0 }}>
                    <Modal.Title>Create New Album</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="create_album_cont">
                        <p>Album Name<br />
                            <input
                                type="text"
                                defaultValue={albumName}
                                onChange={onChangeAlbumName}
                                className='rounded'
                            />
                            {error && <span className='help-text text-danger'>
                                {error}
                            </span>}
                        </p>
                    </div>
                    <div className="create-album-buttons">
                        <span
                            className="btn btn-primary btn-rounded"
                            onClick={handleClose}
                            disabled={busy}
                        >CANCEL</span>
                        <span
                            className="btn btn-primary btn-rounded"
                            onClick={handleSave}
                            disabled={error || busy}
                        >
                            {
                                busy ? 'SAVING...' : 'CREATE'
                            }
                        </span>
                    </div>
                </Modal.Body>
            </Modal >
        }

        {showAlert && <AlertConfirmModal show={showAlert} setShow={handleCloseAlert} modalBody={modalBody} />}
    </>;
};

const mapStateToProps = state => {
    return {
        activeAlbum: state.stash.activeAlbum,
        albumList: state.stash.albums,
        stash: state.stash,
        showAlbumModal: state.stash.showAlbumModal,
        stashSelected: state.stash.stashSelected,
    };
};

export default connect(mapStateToProps)(CreateNewAlbumModal);
